// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/js/chunk" + chunkId + "." + {"47":"fc842ae794f2b7e4","985":"16e426e0e98f2b30"}[chunkId] + ".js";
};